package com.essntl.uikit.components.chat.group

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.chat.contact.ContactAvatar
import com.essntl.uikit.components.chat.contact.ContactTypeUI
import com.essntl.uikit.components.chat.contact.ContactUiState.ContactType
import com.essntl.uikit.components.checkbox.EsCheckBox
import com.essntl.uikit.components.checkbox.EsCheckBoxColors
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsGroupMemberCard(
    name: String,
    phoneNumber: String?,
    type: ContactType?,
    isChecked: Boolean = false,
    showCheckBox: Boolean = true,
    showOptionsIcon: Boolean = false,
    onCheck: (Boolean) -> Unit = {},
    onClick: () -> Unit = {},
) {

    var isDropDownExpanded by remember { mutableStateOf(false) }

    val initials = name.split(" ")
        .filter { it.isNotEmpty() }
        .map { it.first().uppercaseChar() }
        .joinToString("")
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        modifier = Modifier
            .fillMaxWidth()
            .border(
                width = 1.dp,
                color = MaterialTheme.esColorScheme.borderPrimary,
                shape = RoundedCornerShape(16.dp),
            )
            .background(color = Color.White, shape = RoundedCornerShape(16.dp))
            .padding(12.dp),
    ) {
        ContactAvatar(
            initials = initials,
        )

        Column(
            modifier = Modifier.weight(1F),
            verticalArrangement = Arrangement.spacedBy(4.dp),
        ) {
            ContactTypeUI(type)

            Text(
                text = name,
                style = MaterialTheme.esTypography.p2Medium14.copy(color = MaterialTheme.esColorScheme.textPrimary),
            )

            Text(
                text = if (phoneNumber != null) "+$phoneNumber" else "No phone number",
                style = MaterialTheme.esTypography.p2Regular14.copy(color = MaterialTheme.esColorScheme.textSecondary),
            )
        }

        if (showCheckBox)
            EsCheckBox(
                enabled = phoneNumber != null,
                checked = isChecked,
                onCheckedChange = onCheck,
                colors = EsCheckBoxColors(
                    backgroundCheckedBoxColor = MaterialTheme.esColorScheme.primary,
                    backgroundUncheckedBoxColor = MaterialTheme.esColorScheme.secondaryHover,
                    borderCheckedBoxColor = Color.Transparent,
                    checkMarkColor = Color.White,
                    disabledCheckedBoxColor = MaterialTheme.esColorScheme.secondaryDisabled,
                    disabledCheckMarkColor = MaterialTheme.esColorScheme.iconDisabled,
                ),
            )

        if (showOptionsIcon)
            Box {
                EsLargeIcon(
                    res = EsIcons.MoreVertical,
                    modifier = Modifier
                        .clip(CircleShape)
                        .pointerHoverIcon(PointerIcon.Hand)
                        .clickable {
                            isDropDownExpanded = true
                        },
                )

                EsDropDownMenu(
                    expanded = isDropDownExpanded,
                    onDismissRequest = { isDropDownExpanded = false },
                ) {
                    EsDropdownMenuItem(
                        text = "Remove from group",
                        onClick = {
                            isDropDownExpanded = false
                            onClick()
                        },
                        modifier = Modifier.height(40.dp),
                    )
                }
            }
    }
}